import { ParametrosModule } from './views/cadastro/faturamento/parametros/parametros.module';
import { Routes } from '@angular/router';
import { AdminLayoutComponent } from './shared/components/layouts/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './shared/components/layouts/auth-layout/auth-layout.component';
import { AuthGuard } from './shared/guards/auth.guard';
import { UserRoleGuard } from './shared/guards/user-role.guard';
import { config } from 'config';

export const rootRouterConfig: Routes = [
  {
    path: '',
    redirectTo: 'dashboard/main',
    pathMatch: 'full'
  },
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: 'others',
        loadChildren: () => import('./views/others/others.module').then(m => m.OthersModule),
        data: { title: 'Outros', breadcrumb: 'OUTROS' }
      },
      {
        path: 'sessions',
        loadChildren: () => import('./views/sessions/sessions.module').then(m => m.SessionsModule),
        data: { title: 'Session' }
      },
      {
        path: 'shop',
        loadChildren: () => import('./views/shop/shop.module').then(m => m.ShopModule),
        data: { title: 'Shop', breadcrumb: 'SHOP' }
      }
    ]
  },
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    // protege todas as rotas filhas com UserRoleGuard (evita aplicar canActivate em cada child)
    canActivateChild: [UserRoleGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule),
        data: { title: 'Início', breadcrumb: 'Início' }
      },
      {
        path: 'profile',
        loadChildren: () => import('./views/profile/profile.module').then(m => m.ProfileModule),
        data: { title: 'Perfil', breadcrumb: 'Perfil' }
      },
      {
        path: 'transacao_detail',
        loadChildren: () => import('./views/profile/transacao/transacao.module').then(m => m.TransacaoModule)
      },
      {
        path: 'ponto_atendimento_detail',
        loadChildren: () => import('./views/profile/ponto-atendimento/ponto-atendimento.module').then(m => m.PontoAtendimentoModule)
      },
      {
        path: 'supervisorio',
        loadChildren: () => import('./views/automacao/supervisorio/supervisorio.module').then(m => m.SupervisorioModule),
        data: { title: 'Supervisorio', breadcrumb: 'Supervisorio' }
      },
      {
        path: 'supervisorio/receita/padrao/receita_detail',
        loadChildren: () => import('./views/automacao/supervisorio/receita/padrao/receita-padrao.module').then(m => m.ReceitaPadraoModule)
      },
      {
        path: 'supervisorio/receita/producao/receita_detail',
        loadChildren: () => import('./views/automacao/supervisorio/receita/producao/receita-producao.module').then(m => m.ReceitaProducaoModule)
      },
      {
        path: 'cad_cadastros',
        loadChildren: () => import('./views/cadastro/cadastros/cadastros.module').then(m => m.CadastrosModule),
        data: { title: 'Cadastros', breadcrumb: 'Cadastros' }
      },
      {
        path: 'cad_veiculos',
        loadChildren: () => import('./views/cadastro/cadastros/veiculos/veiculo.module').then(m => m.VeiculoModule),
        data: { title: 'Veiculos', breadcrumb: 'Veiculos' }
      },
      {
        path: 'agenda',
        loadChildren: () => import('./views/cadastro/agenda/agenda.module').then(m => m.AgendaModule),
        data: { title: 'Agenda', breadcrumb: 'Agenda' }
      },
      {
        path: 'compromisso',
        loadChildren: () => import('./views/cadastro/compromisso/compromisso.module').then(m => m.CompromissoModule),
        data: { title: 'Compromissos', breadcrumb: 'Compromissos' }
      },
      {
        path: 'cadastro_detail',
        loadChildren: () => import('./views/cadastro/cadastros/cadastro/cadastro.module').then(m => m.CadastroModule)
      },
      {
        path: 'veiculo_detail',
        loadChildren: () => import('./views/cadastro/cadastros/veiculos/veiculo.module').then(m => m.VeiculoModule)
      },
      {
        path: 'parametros',
        loadChildren: () => import('./views/cadastro/faturamento/parametros/parametros.module').then(m => m.ParametrosModule),
        data: { title: 'Parametros', breadcrumb: 'Parametros' }
      },
      {
        path: 'filial',
        loadChildren: () => import('./views/cadastro/cadastros/filial/filial.module').then(m => m.FilialModule),
        data: { title: 'Empresa', breadcrumb: 'Empresa' }
      },
      {
        path: 'filial_detail',
        loadChildren: () => import('./views/cadastro/cadastros/filial/filial.module').then(m => m.FilialModule)
      },
      {
        path: 'cad_faturamento',
        loadChildren: () => import('./views/cadastro/faturamento/faturamento.module').then(m => m.FaturamentoModule),
        data: { title: 'Faturamento', breadcrumb: 'Faturamento' }
      },
      {
        path: 'produto_detail',
        loadChildren: () => import('./views/cadastro/faturamento/produto/produto.module').then(m => m.ProdutoModule)
      },
      {
        path: 'cad_financeiro',
        loadChildren: () => import('./views/cadastro/financeiro/financeiro.module').then(m => m.FinanceiroModule),
        data: { title: 'Financeiro', breadcrumb: 'Financeiro' }
      },
      {
        path: 'lcto_detail',
        loadChildren: () => import('./views/movimentacao/faturamento/lancamento/lancamento.module').then(m => m.LancamentoModule)
      },
      {
        path: 'cte_detail',
        loadChildren: () => import('./views/movimentacao/faturamento/cte/cte.module').then(m => m.CteModule)
      },
      {
        path: 'financ_cc_detail',
        loadChildren: () => import('./views/cadastro/financeiro/financ-cc/financ-cc.module').then(m => m.FinancCCModule)
      },
      {
        path: 'mdfe_detail',
        loadChildren: () => import('./views/movimentacao/faturamento/mdfe/mdfe.module').then(m => m.MdfeModule)
      },
      {
        path: 'fat_movto',
        loadChildren: () => import('./views/movimentacao/faturamento/fat-movto.module').then(m => m.FatMovtoModule),
        data: { title: 'Movimentação/Faturamento', breadcrumb: 'Movimentação/Faturamento' }
      },
      {
        path: 'financ_movto',
        loadChildren: () => import('./views/movimentacao/financeiro/financ-movto.module').then(m => m.FinancMovtoModule),
        data: { title: 'Movimentação/Financeiro', breadcrumb: 'Movimentação/Financeiro' }
      },
      {
        path: 'relatorio',
        loadChildren: () => import('./views/relatorio/relatorio.module').then(m => m.RelatorioModule),
        data: { title: 'Relatorio', breadcrumb: 'Relatorio' }
      },
      {
        path: 'utilitario',
        loadChildren: () => import('./views/utilitario/utilitario.module').then(m => m.UtilitarioModule),
        data: { title: 'Utilitario', breadcrumb: 'Utilitario' }
      },
      // Removido canActivate redundante: canActivateChild já protege estas rotas.
      {
        path: 'utilitario/compromisso',
        loadChildren: () => import('./views/cadastro/compromisso/compromisso.module').then(m => m.CompromissoModule),
        data: { title: 'Compromissos', breadcrumb: 'Compromissos' }
      },
      {
        path: 'utilitario/notificacao_detail',
        loadChildren: () => import('./views/utilitario/notificacao/notificacao.module').then(m => m.NotificacaoModule),
        data: { title: 'Notificação', breadcrumb: 'Notificação', roles: config.authRoles.ROLE_ROOT }
      },
      {
        path: 'utilitario/banner_detail',
        loadChildren: () => import('./views/utilitario/banner/banner.module').then(m => m.BannerModule),
        data: { title: 'Banner', breadcrumb: 'Banner', roles: config.authRoles.ROLE_ADMIN }
      },
      {
        path: 'liberacao',
        loadChildren: () => import('./views/liberacao/liberacao.module').then(m => m.LiberacaoModule),
        data: { title: 'Liberação', breadcrumb: 'Liberação', roles: config.authRoles.ROLE_ROOT }
      },
      {
        path: 'search',
        loadChildren: () => import('./views/search-view/search-view.module').then(m => m.SearchViewModule)
      },
      {
        path: 'marketplace',
        loadChildren: () => import('./views/marketplace/marketplace.module').then(m => m.MarketplaceModule),
        data: { title: 'Marketplace', breadcrumb: 'MARKETPLACE' }
      },
      {
        path: 'mark_parameter_detail',
        loadChildren: () => import('./views/marketplace/parameter/parameter.module').then(m => m.ParameterModule)
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'sessions/404'
  }
];